import { render, staticRenderFns } from "./SurveyDefaultQuestions.vue?vue&type=template&id=74d9c68e"
import script from "./SurveyDefaultQuestions.vue?vue&type=script&lang=js"
export * from "./SurveyDefaultQuestions.vue?vue&type=script&lang=js"
import style0 from "./SurveyDefaultQuestions.vue?vue&type=style&index=0&id=74d9c68e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports